import React from 'react'
import moment from 'moment'
import numeral from 'numeral'
import Currency from '../../../components/Currency'
import NumberFormat from '../../../components/NumberFormat'
import PercentageFormat from '../../../components/PercentageFormat'
import ValueMovement from '../../../components/ValueMovement'
import KeyMetrics from '../components/KeyMetrics'

const CustomTooltip = ({ label, value }) => (
    <div className="custom-tooltip">
        <span>
            <strong>{label}:</strong>
        </span>
        <span style={{ marginLeft: 10 }}>{value}</span>
    </div>
)

const calculatePercentage = (a, b) => {
    if (b === 0) return 0

    const percentage = a / b
    return percentage * 100
}

const SalesTab = {
    label: 'Sales',
    tickFormatter: value => numeral(value).format('0[.]0a'),
    renderTab: ({
        numberOfTickets: { total, changeToCumulativeTotalSinceYesterday },
    }) => (
        <div className="key-value">
            <NumberFormat value={total} />
            <ValueMovement
                value={changeToCumulativeTotalSinceYesterday}
                component={NumberFormat}
            />
        </div>
    ),
    tooltip: ({ active, payload, label }) =>
        active && payload && payload.length > 0 ? (
            <CustomTooltip
                label={moment(label).format('DD MMM YYYY')}
                value={numeral(payload[0].value).format('0,0')}
            />
        ) : null,
    mapDataForChart: data =>
        Object.keys(data.groups).map(groupDateUtc => ({
            x: groupDateUtc,
            y: data.groups[groupDateUtc].numberOfTickets,
        })),
}

const SalesValueTab = {
    label: 'Sales Value',
    tickFormatter: value => numeral(value).format('$ 0[.]0a'),
    renderTab: ({
        valueOfTickets: { total, changeToCumulativeTotalSinceYesterday },
    }) => (
        <div className="key-value">
            <Currency value={total} />
            <ValueMovement
                value={changeToCumulativeTotalSinceYesterday}
                component={Currency}
            />
        </div>
    ),
    tooltip: ({ active, payload, label }) =>
        active && payload && payload.length > 0 ? (
            <CustomTooltip
                label={moment(label).format('DD MMM YYYY')}
                value={numeral(payload[0].value).format('$ 0,0.00')}
            />
        ) : null,
    mapDataForChart: data =>
        Object.keys(data.groups).map(groupDateUtc => ({
            x: groupDateUtc,
            y: data.groups[groupDateUtc].valueOfTickets,
        })),
}

const SalesAsPercentage = (ticketsAvailable, percentSold) => ({
    label: '% Sold',
    tickFormatter: value => `${value} %`,
    renderTab: ({ numberOfTickets: { total } }) => (
        <div className="key-value">
            <PercentageFormat value={percentSold} />
            <div className="description">
                {total} / {ticketsAvailable}
            </div>
        </div>
    ),
    tooltip: ({ active, payload, label }) =>
        active && payload && payload.length > 0 ? (
            <CustomTooltip
                label={moment(label).format('DD MMM YYYY')}
                value={numeral(payload[0].value / 100).format('0.00 %')}
            />
        ) : null,
    mapDataForChart: data =>
        Object.keys(data.groups).map(groupDateUtc => ({
            x: groupDateUtc,
            y: calculatePercentage(
                data.groups[groupDateUtc].cumulativeNumberOfTickets,
                ticketsAvailable,
            ),
        })),
})

const getSelections = ({ ticketsAvailable, percentSold }) => [
    SalesTab,
    SalesValueTab,
    SalesAsPercentage(ticketsAvailable, percentSold),
]

const KeyMetricSales = props => (
    <KeyMetrics
        {...props}
        selections={getSelections(props.event)}
        data={props.data}
    />
)

export default KeyMetricSales
